export const handleChangeInputSupportPage = (name, value) => ({
    type: 'CHANGE_INPUT_PAGE_SUPPORT', name, value
});

export const handleChangeDisabledBtnPageSupport = (disabledBtn) => ({
    type: 'CHANGE_DISABLE_BTN_PAGE_SUPPORT', disabledBtn
});

export const handleChangeLoaderPageSupport = (isLoading) => ({
    type: 'CHANGE_LOADER_PAGE_SUPPORT', isLoading
});

export const handleChangeBtnClassPageSupport = (className) => ({
    type: 'CHANGE_BTN_CLASS_PAGE_SUPPORT', className
});